import { useState } from 'react';

import Overlay from './Components/HomePage/Overlay';
import Consent from './Components/HomePage/Consent';
import HomePage from './Components/HomePage/HomePage';
import MenuPanel from './Components/Menu/MenuPanel';
import NotFound from './Components/HomePage/NotFound';

import { CartContext } from './Components/CartContext';
import { TopMenuContext } from './Components/TopMenuContext';

import { connect } from 'react-redux';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';

import './App.css';

const mapStateToProps = (state) => {
  return {
    restaurantID: state.restaurantID,
  }
}

const App = () => {

  const [cart, setCart] = useState(new Array());
  const [topMenuValues, setTopMenuValues] = useState({
    stimaConto: false,
  });

  return (
    <BrowserRouter basename="/web">
      <Consent />

      <TopMenuContext.Provider value={[topMenuValues, setTopMenuValues]}>
        <Overlay />
      </TopMenuContext.Provider>

      <Switch>
        <Route path="/404">
          <NotFound />
        </Route>
        <Redirect exact from="/:id" to="/:id/Home" />
        <Route path="/:id/Home" children={<HomePage />} />
        <Redirect exact from="/" to="/404" />
        <TopMenuContext.Provider value={[topMenuValues, setTopMenuValues]}>
          <CartContext.Provider value={[cart, setCart]}>
            <Route path="/:id/:categoryID">
              <MenuPanel />
            </Route>
          </CartContext.Provider>
        </TopMenuContext.Provider>

        <Route path="*" children={<NotFound />} />

      </Switch>
    </BrowserRouter>
  )
}

//<Redirect exact from="/" to="/-METR84BH52iJegO4Ous" />

export default connect(mapStateToProps)(App);
